<app-box-filter
  [individualFilter]="individualFilter"
  [index]="index"
  [label]="label"
  [show]="isOpenBox"
  (toggleShow)="toggleOpenBox()">
  <div class="range-boxes" *ngIf="!isRadioBox" [class.range-boxes--adjust]="individualFilter">
    <div *ngFor="let widget of widgets" class="chip">
      <app-ds-chip-choice
        [icon]="widget.Icon"
        [mainText]="!isPrice ? (widget.Label | transloco) : isPrice ? getPriceRangeDescription(widget) : ''"
        [secondaryText]="
          type === FilterTypes.DepartureTimes ? getInfoDepartureDescription(widget.HourLimits) : 
          type === FilterTypes.SectorDurations ? getSectorDurationDescription(widget.HourLimits) : ''"
        [style]="chipChoiceStyle" 
        [size]="chipChoiceSize"
        [state]="chipChoiceState(isActive(widget))"
        (clickEvent)="selectedValue(widget)">
      </app-ds-chip-choice>
    </div>
    <!-- Temporarily Disabled -->
    <ng-container *ngIf="type === FilterTypes.PriceRange">
      <div class="chip">
        <app-ds-chip-choice
          [mainText]="'FLIGHT_RESULTS_MODULE.FILTER_SECTION.CUSTOM' | transloco"
          [style]="chipChoiceStyle" 
          [size]="chipChoiceSize"
          [state]="chipChoiceState(showCustomRange)"
          (clickEvent)="customRange()">
        </app-ds-chip-choice>
      </div>
    </ng-container>
    <!-- / Temporarily Disabled -->
  </div>

  <div class="radio-boxes" *ngIf="isRadioBox">
    <ng-container *ngFor="let widget of widgets">
      <div class="radio">
        <app-ds-radio-button
          [checked]="isActive(widget)"
          [title]="{
            Label: type === FilterTypes.PriceRange ? getPriceRangeDescription(widget) :
                   type === FilterTypes.DepartureTimes ? getInfoDepartureDescription(widget) :
                   type === FilterTypes.SectorDurations ? getSectorDurationDescription(widget) : ''
          }"
          (radioOnChecked)="selectedValue(widget)">
        </app-ds-radio-button>
      </div>
    </ng-container>
    <!-- Temporarily Disabled -->
    <ng-container *ngIf="type === FilterTypes.PriceRange">
      <div class="radio">
        <app-ds-radio-button
          [checked]="showCustomRange"
          [title]="{
            Label: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.CUSTOM' | transloco
          }"
          (radioOnChecked)="customRange()">
        </app-ds-radio-button>
      </div>
    </ng-container>
    <!-- / Temporarily Disabled -->
  </div>

  <ng-container *ngIf="showCustomRange" [ngSwitch]="type">
    <ng-container *ngSwitchCase="FilterTypes.PriceRange">
      <div class="custom-range">
        <app-form-currency-input
          [form]="priceForm"
          [formControlSelector]="priceItemForm"
          [id]="priceItemForm"
          [isSubmitted]="false"
          [style]="'flight-filter'"
          [placeholder]="'GENERAL_WIDGET_MODULE.PRICE_WIDGET.PRICE_PER_PERSON' | transloco"
          (inputChange)="inputChange($event)">
        </app-form-currency-input>
      </div>
    </ng-container>
    <!-- Temporarily Disabled -->
    <ng-container *ngIf="false">
      <ng-container *ngSwitchCase="FilterTypes.DepartureTimes">
        <app-air-timepicker
          [initialPlaceHolder]="'FLIGHT_RESULTS_MODULE.FILTER_SECTION.DEPARTURE_TIMES.DEPARTURE_AFTER' | transloco"
          [initValue]="minFlightTime"
          [value]="selectedCustomValues[0] || ''"
          [minTime]="minTime"
          [maxTime]="maxTime"
          (timeSelection)="timeSelection($event, true)">
        </app-air-timepicker>
        <app-air-timepicker
          [initialPlaceHolder]="'FLIGHT_RESULTS_MODULE.FILTER_SECTION.DEPARTURE_TIMES.DEPARTURE_BEFORE' | transloco"
          [initValue]="maxFlightTime"
          [value]="selectedCustomValues[1] || ''"
          [minTime]="minTime"
          [maxTime]="maxTime"
          (timeSelection)="timeSelection($event, false)">
        </app-air-timepicker>
      </ng-container>
      <ng-container *ngSwitchCase="FilterTypes.SectorDurations">
        <app-air-timepicker
          [initialPlaceHolder]="'FLIGHT_RESULTS_MODULE.FILTER_SECTION.SECTOR_DURATION.MIN_DURATION' | transloco"
          [initValue]="minSectorDuration"
          [value]="selectedCustomValues[0] || ''"
          [minTime]="timeDuration(minSectorDuration, true)"
          [maxTime]="timeDuration(maxSectorDuration, false)"
          (timeSelection)="timeSelection($event, true)">
        </app-air-timepicker>
        <app-air-timepicker
          [initialPlaceHolder]="'FLIGHT_RESULTS_MODULE.FILTER_SECTION.SECTOR_DURATION.MAX_DURATION' | transloco"
          [initValue]="maxSectorDuration"
          [value]="selectedCustomValues[1] || ''"
          [minTime]="timeDuration(minSectorDuration, true)"
          [maxTime]="timeDuration(maxSectorDuration, false)"
          (timeSelection)="timeSelection($event, false)">
        </app-air-timepicker>
      </ng-container>
    </ng-container>
    <!-- / Temporarily Disabled -->
  </ng-container>
</app-box-filter>